import { Field } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import {
  CLASS_NAMES,
  PLACE_HOLDER_PROPS,
  VALIDATION_MESSAGE,
} from './constants';

export interface AcceptTermsInputProps {
  name?: string;
  label?: string;
  linkLabel?: string;
  showLinkLabel?: boolean;
  isLoading?: boolean;
}

const AcceptTermsInput = ({
  name = 'acceptedTerms',
  label = '',
  linkLabel = '',
  showLinkLabel,
  isLoading,
}: AcceptTermsInputProps) => (
  <div className={CLASS_NAMES.container}>
    <Field.Validator
      validation={{
        required: {
          value: true,
          message: VALIDATION_MESSAGE,
        },
      }}
    >
      <Field.BooleanInput
        placeholder="enabled?"
        name={name}
        handle="checkbox"
        isLoading={isLoading}
        fieldText={
          <p>
            <Text text={label} className="text-style-14-22" />
            {showLinkLabel && (
              <Text text={linkLabel} {...PLACE_HOLDER_PROPS.link} />
            )}
          </p>
        }
      />
    </Field.Validator>
  </div>
);

AcceptTermsInput.defaultProps = {
  label: 'I have read and agree to ',
  linkLabel: "Kanda's Terms & Conditions",
  showLinkLabel: true,
};

export default AcceptTermsInput;
